import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import React from "react";
import axios from "axios";

export const exportToExcelGrupos = async ({
  datosFiltradosPorOrden,
  modoArmarGrupo,
  pilotosSeleccionados,
  modoArmarGrupoTotales,
  MySwal,
  idAsociacion,
  idCategoria,
  tituloBanner,
  tituloPDF,
  columns,
  filtrarUltimaColumna,
  pilotoCubiertas,
}) => {
  const ahora = new Date();
  const fecha = `${ahora.getDate()}/${ahora.getMonth() + 1}/${ahora.getFullYear()}`;
  const hora = `${ahora.getHours()}:${ahora.getMinutes()}:${ahora.getSeconds()}`;

  let datosParaExportar = [...datosFiltradosPorOrden];

  if (modoArmarGrupo) {
    if (pilotosSeleccionados.length === 0) {
      MySwal.fire({
        text: "Debes seleccionar al menos un piloto para generar el Excel.",
        icon: "warning",
        confirmButtonText: "Ok",
      });
      return;
    }

    const seleccionados = datosFiltradosPorOrden.filter((item) =>
      pilotosSeleccionados.includes(
        modoArmarGrupoTotales ? item.id : item.id_piloto
      )
    );

    if (modoArmarGrupoTotales) {
      datosParaExportar = [...seleccionados]
        .sort((a, b) => a.orden - b.orden)
        .map((piloto, index) => ({
          ...piloto,
          orden_global: index + 1,
        }));
    } else {
      datosParaExportar = [...seleccionados].sort((a, b) => a.orden - b.orden);
    }
  }

  let asociacionesData = null;
  let nombreCategorias = "";

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_DOMINIO}/asociacion-detalles/${idAsociacion}`
    );
    asociacionesData = response.data;
  } catch (error) {
    console.error("Error al obtener asociación:", error);
  }

  if (idCategoria) {
    try {
      const responseCategoria = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/categoria/${idCategoria}`
      );
      nombreCategorias = responseCategoria.data.categoria || "";
    } catch (error) {
      console.error("Error al obtener categoría:", error);
    }
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Pilotos");

  const filteredColumns = filtrarUltimaColumna ? columns.slice(0, -1) : columns;

  const columnHeaders = filteredColumns.map((col) =>
    typeof col.title === "function"
      ? col.title().props.children.props.children
      : col.title
  );

  const getCellValue = (col, row, index) => {
    if (col.key === "orden") {
      return modoArmarGrupoTotales
        ? row.orden_global || index + 1
        : row.orden || index + 1;
    }

    if (col.key === "categorias") {
      if (!row?.inscripciones || row.inscripciones.length === 0) {
        return "No tiene categorías vinculadas";
      }

      const categoriasUnicas = Array.from(
        new Map(
          row.inscripciones.map((i) => [i.id_categoria, i.categoria])
        ).values()
      );

      return categoriasUnicas.join(", ");
    }

    if (col.key === "piloto") {
      return `${row.apellido || ""}, ${row.nombre || ""}`.trim();
    }

    if (col.key === "fecha_nacimiento") {
      return row.fecha_nacimiento
        ? moment(`${row.fecha_nacimiento}`, "YYYY-MM-DD").format("DD/MM/YYYY")
        : "-";
    }

    let value = col.render
      ? col.render(row[col.dataIndex || col.key], row)
      : row[col.dataIndex || col.key];

    if (React.isValidElement(value)) {
      const children = React.Children.toArray(value.props.children);
      value = children
        .map((child) =>
          typeof child === "string" || typeof child === "number"
            ? String(child)
            : ""
        )
        .join(" ");
    }

    return value || "-";
  };

  worksheet.mergeCells("A1:G1");
  worksheet.getCell("A1").value = asociacionesData?.nombre?.toUpperCase() || "";
  worksheet.getCell("A1").font = { bold: true, size: 16 };
  worksheet.getCell("A1").alignment = { horizontal: "center" };
  worksheet.getCell("A1").fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFDCDCDC" },
  };

  worksheet.mergeCells("A2:G2");
  worksheet.getCell("A2").value = (tituloBanner || "Pilotos totales").toUpperCase();
  worksheet.getCell("A2").font = { bold: true, size: 15 };
  worksheet.getCell("A2").alignment = { horizontal: "center" };
  worksheet.getCell("A2").fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFDCDCDC" },
  };

  worksheet.mergeCells("A3:G3");
  worksheet.getCell("A3").value = pilotoCubiertas || nombreCategorias.toUpperCase();
  worksheet.getCell("A3").font = { bold: true, size: 14 };
  worksheet.getCell("A3").alignment = { horizontal: "center" };
  worksheet.getCell("A3").fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFDCDCDC" },
  };

  worksheet.getCell("A5").value = `Fecha: ${fecha}`;
  worksheet.getCell("A5").font = { bold: true };

  worksheet.addRow([]);

  const headerRow = worksheet.addRow(columnHeaders);

  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF223463" },
    };
    cell.alignment = { horizontal: "center", vertical: "middle" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  datosParaExportar.forEach((row, index) => {
    const fila = filteredColumns.map((col) => getCellValue(col, row, index));
    const excelRow = worksheet.addRow(fila);

    excelRow.eachCell((cell) => {
      cell.alignment = {
        vertical: "middle",
        horizontal: "left",
        wrapText: true,
      };

      cell.border = {
        top: { style: "thin", color: { argb: "FFE0E0E0" } },
        left: { style: "thin", color: { argb: "FFE0E0E0" } },
        bottom: { style: "thin", color: { argb: "FFE0E0E0" } },
        right: { style: "thin", color: { argb: "FFE0E0E0" } },
      };

      if (index % 2 !== 0) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF5F5F5" },
        };
      }
    });
  });

  worksheet.columns.forEach((column, index) => {
    const widths = [10, 15, 30, 18, 18, 22, 40];
    column.width = widths[index] || 20;
  });

  worksheet.views = [{ state: "frozen", ySplit: 7 }];

  const buffer = await workbook.xlsx.writeBuffer();

  saveAs(
    new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    `${tituloPDF}_${fecha.replace(/\//g, "-")}_${hora.replace(/:/g, "-")}.xlsx`
  );
};